import type { TFunction } from 'i18next'

import { InvoiceBillingStage } from '../enums/invoiceBillingStage'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import type { RelatedInvoice } from '../types/relatedInvoice'
import { getRelatedInvoiceDocumentType } from './depositInvoices/getRelatedInvoiceDocumentType'

// A draft has no real document number yet - the BE contract can still send one on relatedInvoices
// entries (see getRelatedInvoiceDocumentType), but it isn't final and may collide with a since-issued
// invoice's number, so it must not be shown until the draft is issued.
export const getRelatedInvoiceDocumentName = (invoice: RelatedInvoice, t: TFunction): string => {
  const isDraft = getRelatedInvoiceDocumentType(invoice) === InvoiceDocumentType.InvoiceDraft
  const invoiceNumber = {
    documentNumber: invoice.invoiceNumber,
  }
  switch (invoice.billingStage) {
    case InvoiceBillingStage.Deposit:
      return isDraft
        ? t('deposit_invoice')
        : t('external_invoices.related_invoice.document_name.deposit', invoiceNumber)
    case InvoiceBillingStage.Final:
      return isDraft ? t('final_invoice') : t('external_invoices.related_invoice.document_name.final', invoiceNumber)
    default:
      return isDraft ? t('invoice') : t('external_invoices.related_invoice.document_name.invoice', invoiceNumber)
  }
}
